import { Injectable } from '@angular/core';
import { EnvService } from 'src/services/env.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';

/**
 * com.vertafore.plm.user.TermsOfService
 */
export interface TermsOfService {
    termsOfServiceType: string;
    id: string;
    content: string;
}

/**
 * Http service to get terms of service.
 *
 * most http services return an observable, but in this case we have to return a response due to the caching architecture
 *  central caching service will replace this and at that time we can re architect this to be an observable
 */
@Injectable({ providedIn: 'root' })
export class TermsOfServiceHttpService {

    cachedTermsOfService: any = {};

    constructor(private http: HttpClient,
                private env: EnvService) {
    }

    /**
     * @deprecated use {@link getFirmTermsOfServiceAsObservable}
     */
    getFirmTermsOfService(): Promise<TermsOfService> {
        return this.getTermsOfService('firm', 'sircon_firm');
    }

    getFirmTermsOfServiceAsObservable(): Observable<TermsOfService> {
        return this.getTermsOfServiceAsObservable('firm', 'sircon_firm');
    }

    /**
     * @deprecated use {@link getAgencyTermsOfServiceAsObservable}
     */
    getAgencyTermsOfService(): Promise<TermsOfService> {
        return this.getTermsOfService('agency', 'sircon_agency');
    }

    getAgencyTermsOfServiceAsObservable(): Observable<TermsOfService> {
        return this.getTermsOfServiceAsObservable('agency', 'sircon_agency');
    }

    /**
     * @deprecated use {@link getEducationProviderTermsOfServiceAsObservable}
     */
    getEducationProviderTermsOfService(): Promise<TermsOfService> {
        return this.getTermsOfService('educationProvider', 'sircon_education_provider');
    }

    getEducationProviderTermsOfServiceAsObservable(): Observable<TermsOfService> {
        return this.getTermsOfServiceAsObservable('educationProvider', 'sircon_education_provider');
    }

    /**
     * @deprecated use {@link getIndividualTermsOfServiceAsObservable}
     */
    getIndividualTermsOfService(): Promise<TermsOfService> {
        return this.getTermsOfService('individual', 'sircon_indv');
    }

    getIndividualTermsOfServiceAsObservable(): Observable<TermsOfService> {
        return this.getTermsOfServiceAsObservable('individual', 'sircon_indv');
    }

    /**
     * @deprecated use {@link getFCRATermsOfServiceAsObservable}
     */
    getFCRATermsOfService(): Promise<TermsOfService> {
        return this.getTermsOfService('fcra', 'fcra');
    }

    getFCRATermsOfServiceAsObservable(): Observable<TermsOfService> {
        return this.getTermsOfServiceAsObservable('fcra', 'fcra');
    }

    private getTermsOfServiceAsObservable(cachedTermsOfServiceKey: string, termsOfServiceType: string): Observable<TermsOfService> {
        if (this.cachedTermsOfService[ cachedTermsOfServiceKey ]) {
            return of(this.cachedTermsOfService[ cachedTermsOfServiceKey ]);
        } else {
            return this.http.get<TermsOfService>(this.env.EDGE_SERVICE_PATH + `/terms?type=${termsOfServiceType}`)
                .pipe((tap(value => this.cachedTermsOfService[ cachedTermsOfServiceKey ] = value)));
        }
    }

    /**
     * @deprecated use {@link getTermsOfServiceAsObservable}
     */
    private getTermsOfService(cachedTermsOfServiceKey: string, termsOfServiceType: string): Promise<TermsOfService> {
        return this.getTermsOfServiceAsObservable(cachedTermsOfServiceKey, termsOfServiceType).toPromise();
    }
}
